<template>
    <div>
        <div class="row justify-content-between mb-3">
            <div class="col-12 mb-3 text-right">
                <b-button v-b-modal="'addSancionModal'">Crear</b-button>
            </div>
            <b-modal id="addSancionModal" size="lg" title="CREAR SANCIÓN" hide-footer centered v-model="crear">
                <AddSanciones :base_id="base_id" @crearSancion="getSanciones(), crear = false" />
            </b-modal>
            <div class="responsive col-12 col-md-3">
                <SearchComponent v-model="filters.search" v-on:search="getSanciones" :disabled="loading"/>
            </div>
            <div class="col-12 col-md-3 mt-2 mt-md-0">
                <div class="input-group input-group-sm">
                    <select class="custom-select" v-model="filters.pagado" :disabled="loading">
                        <option :value="null">Estado</option>
                        <option value="1">Pagado</option>
                        <option value="0">No pagado</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-md-3 mt-2 mt-md-0">
                <div class="input-group input-group-sm">
                    <select class="custom-select" v-model="filters.impuesta" :disabled="loading">
                        <option :value="null">Sanción impuesta por</option>
                        <option value="0">Federación</option>
                        <option value="1">Club</option>
                        <option value="2">Cuerpo técnico</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-md-3 mt-2 mt-md-0">
                <div class="input-group input-group-sm">
                    <select class="custom-select" v-model="filters.pagar" :disabled="loading">
                        <option :value="null">Pagado por</option>
                        <option value="0">Club</option>
                        <option value="1">Deportista</option>
                    </select>
                </div>
            </div>
        </div>

        <div v-if="loading" class="text-center mt-4">
            <b-spinner label="Cargando..."></b-spinner>
        </div>
        <div v-else>
            <b-table hover :items="sanciones.data" :fields="fields" id="sanciones-table">
                <template #cell(importe)="{ item }">
                    {{ item.importe | formatear_precio }}
                </template>
                <template #cell(impuesta)="{ item }">
                    {{ item.impuesta.nombre ?? item.impuesta }}
                </template>
                <template #cell(pagar)="{ item }">
                    {{ item.pagar.nombre ?? item.pagar }}
                </template>
                <template #cell(pagado)="{ item }">
                    <span v-if="item.pagado" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                    <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                </template>
                <template #cell(id)="{ item, index }"> 
                    <OpcionesDropdownTableComponent 
                        :lastIndex="sanciones.data.length > 3 && index >= sanciones.data.length - 3"
                        :options="[
                            { type: 'action', action:() => $modal.show('editar-sancion-' + item.id), label: 'Editar'},
                            { type: 'action', action:() => $modal.show('borrar-sancion-' + item.id), label: 'Borrar'}
                        ]"
                    /> 
                    <EditarSancion :base_id="base.id" :sancion="item" @close="cerrarModal" @getSanciones="getSanciones" />
                    <BorrarSancion :deportista="base" :sancion="item" @close="cerrarModal" @getSanciones="getSanciones" /> 
                </template>
            </b-table>
            <hr>
            <div class="row justify-content-between">
                <div class="responsive">
                    <ElementosPorPaginaComponent v-model="filters.per_page"/>
                </div>
                <div class="responsive" v-if="sanciones">
                    <PaginateComponent :current_page="sanciones.meta.current_page" :last_page="sanciones.meta.last_page" v-on:change_page="setPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';
import SearchComponent from "@/components/backend/components/SearchComponent";
import ElementosPorPaginaComponent from "@/components/backend/components/ElementosPorPaginaComponent";
import AddSanciones from '../sanciones/AddSanciones';
import EditarSancion from '../sanciones/EditarSancion';
import BorrarSancion from '../sanciones/BorrarSancion.vue';
import OpcionesDropdownTableComponent from '../../components/OpcionesDropdownTableComponent.vue';


export default {
    props: ['base_id', 'base'],
    data() {
        return {
            loading: true,
            sanciones: null,
            debouncedgetSanciones: null,
            filters: {
                per_page: 10,
                page: 1,
                search: '',
                pagado: null,
                impuesta: null,
                pagar: null
            },
            fields: [
                { key: 'fecha', label: 'Fecha', class: 'text-center' },
                { key: 'motivo', label: 'Motivo', class: 'text-center' },
                { key: 'descripcion', label: 'Descripción', class: 'text-center' },
                { key: 'importe', label: 'Importe', class: 'text-center' },
                { key: 'sancion', label: 'Sanción', class: 'text-center' },
                { key: 'sin_jugar_hasta', label: 'Sin jugar hasta', class: 'text-center' },
                { key: 'impuesta', label: 'Impuesta', class: 'text-center' },
                { key: 'pagar', label: 'Deudor', class: 'text-center' },
                { key: 'pagado', label: 'Pagado', class: 'text-center' },
                { key: 'id', label: 'opciones', class: 'text-center' },
            ],
            crear: false
        }
    },
    created() {
        this.debouncedgetSanciones = _.debounce(this.getSanciones, 500);
        this.getSanciones();
    },
    methods: {
        getSanciones() {
            this.loading = true;

            const filters = { ...this.filters };

            Object.keys(filters).forEach(key => {
                if (filters[key] === null) {
                    delete filters[key];
                }
            });

            const params = {
                base_id: this.base_id,
                lista_id: this.$route.params.lista_id,
                filters : filters
            };

            this.$store.dispatch(this.config.getVuexAlias('back.bases.sanciones'), params).then(res => {
                this.sanciones = res.data;
            }).finally(() => this.loading = false);
        },
        setPage(page) {
            this.filters.page = page;
            this.debouncedgetSanciones();
        },
        cerrarModal(modal, actualizar) {
            this.$modal.hide(modal);
            if(actualizar) {
                this.$emit('actualizar');
            }
        },
    },

    watch : {
        'filters.search'(){
            this.filters.page = 1;
            this.debouncedgetSanciones();
        },
        'filters.pagado'() {
            this.filters.page = 1;
            this.debouncedgetSanciones();
        },
        'filters.impuesta'() {
            this.filters.page = 1;
            this.debouncedgetSanciones();
        },
        'filters.pagar'() {
            this.filters.page = 1;
            this.debouncedgetSanciones();
        }
    },
    components: {
        ElementosPorPaginaComponent, SearchComponent, PaginateComponent, AddSanciones, EditarSancion, BorrarSancion, OpcionesDropdownTableComponent
    }
}
</script>